import React, { useEffect, useState } from "react";
import { Form, Input, Select, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { ReloadTrue, hideLoading, showLoading } from "../redux/rootSlice";
import axios from "axios";

const AdminIntro = () => {
    const { portfolioData } = useSelector((state) => state.root);
    const { intro } = portfolioData || {};
    const [selectItemEdit, setselectItemEdit] = useState(null);
    const [showedit, setshowedit] = useState(false);
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        if (intro != null) {
            setshowedit(true);
        } else {
            setshowedit(false);
        }
    }, [intro]);


    const onFinish = async (values) => {
        try {
            let response
            dispatch(showLoading());
            if (selectItemEdit) {
                response = await axios.post(`https://backendz182.up.railway.app/api/portfolio/update-intro/${selectItemEdit?._id}`,
                    values
                );
            } else {
                response = await axios.post("https://backendz182.up.railway.app/api/portfolio/add-intro", values);
            }

            dispatch(hideLoading());

            if (response.data.success) {
                dispatch(ReloadTrue());
                message.success(response.data.message);

            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            console.error("Error:", error);
            message.error("An error occurred. Please try again.");
        }
    };



    return (
        <div>

            <div className="px-5 py-2 flex flex-col gap-3">
                <p className="text-xl font-bold">Add About Details</p>

                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                    initialValues={intro}
                    style={{ width: 550 }}
                    variant="filled"
                >
                    <Form.Item label="Image URL" name="img" className="font-semibold">
                        <Input className="h-[40px]" required placeholder="Enter Image URL" />
                    </Form.Item>
                    <Form.Item label="Salution" name="salution" className="font-semibold">
                        <Input className="h-[40px]" required placeholder="Enter Salutation" />
                    </Form.Item>
                    <Form.Item label="Description 1" name="desc1" className="font-semibold">
                        <TextArea
                            className="h-[100px]"
                            rows="5"
                            required
                            placeholder="Enter Description"
                        />
                    </Form.Item>
                    <Form.Item label="Description 2" name="desc2" className="font-semibold">
                        <TextArea
                            className="h-[100px]"
                            rows="5"
                            required
                            placeholder="Enter Description"
                        />
                    </Form.Item>
                    <Form.Item label="Skills" name="skills" className="font-semibold">
                        {/* <TextArea className="h-[100px]" rows="5" placeholder="Enter Skills" /> */}
                        <Select
                            mode="tags"
                            placeholder="Enter Skills"
                            style={{ width: "100%" }}
                            tokenSeparators={[","]}
                        />
                    </Form.Item>

                    <Form.Item>
                        <button
                            className="h-[40px] float-right bg-transparent hover:bg-primary text-primary-700 font-semibold hover:text-white py-2 px-4 border border-primary hover:border-transparent rounded"
                            type="submit"
                            onClick={() => {
                                setselectItemEdit(intro)
                            }}
                        >
                            {showedit ? "Update" : "Add"}
                        </button>
                    </Form.Item>
                </Form>

            </div>
        </div>
    );
};

export default AdminIntro;
